import React from "react";
import {useSelector} from "react-redux";

const WeeklyMenuSwiper = () => {
  const menuList = useSelector((state) => state.menu);
  
  return (
    <div className="flex justify-center px-4 md:px-10">
      {menuList?.map((i) => (
        <div
          key={i.id}
          className="flex w-full justify-center shadow-white p-5 rounded-lg h-full mb-20"
        >
          <div
            className="text-gray prose prose-base max-w-none leading-relaxed font-sans"
            dangerouslySetInnerHTML={{__html: i.content}}
          />
        </div>
      ))}
    </div>
  );
};

export default WeeklyMenuSwiper;

// <div className="flex justify-center px-4 md:px-10">
// {menuList?.map((i) => (
//   <div
//     key={i.id}
//     className="flex w-full justify-center shadow-white p-5 rounded-lg h-full mb-20"
//   >
//     <div
//     className="text-gray"
//       dangerouslySetInnerHTML={{ __html: i.content }}
//     />
//   </div>
// ))}
// </div>
